/**
 * The one support address the SPA ever shows a user.
 *
 * It had been copied as a local `RECOVERY_EMAIL` const into four surfaces
 * (StepUpProvider, OnboardingFlow, FirstRunGate, LinkLoginModal), and changing
 * it meant finding all four. It lives here so it changes once.
 *
 * This is deliberately NOT the `hello@` address on steward-site's contact page.
 * Everywhere it appears, the user is stuck and needs the queue an operator
 * actually works: locked out of both factors (there is no self-service MFA
 * recovery by design, so a human clearing it is the ONLY way back in, see
 * crossmarc-ops docs/11), signed up without an active subscription, or unable
 * to add a login. A general enquiries inbox is the wrong destination for those.
 */
export const SUPPORT_EMAIL = 'support@steward.crossmarc.com';
